import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';

import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { EnrollmentUserCreationDialogContainerComponent } from '../enrollment-user-creation-dialog-container/enrollment-user-creation-dialog-container.component';
import { DIALOG_SIZE_MEDIUM } from '../../../shared/components/dialog/dialog-sizes';

/**
 * A component that opens a dialog and navigates back when the dialog is closed.
 * It will only navigate back, when the current URL contains '/dialog',
 * to prevent unwanted navigation when the dialog is closed by other means than the user explicitly closing it.
 */
@Component({
  selector: 'app-route-aware-portal-dialog',
  imports: [RouterModule, MatDialogModule],
  template: '',
})
export class RouteAwarePortalDialogComponent implements OnInit {
  dialog = inject(MatDialog);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);

  ngOnInit(): void {
    this.openDialog();
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(
      EnrollmentUserCreationDialogContainerComponent,
      {
        autoFocus: false,
        ...DIALOG_SIZE_MEDIUM,
      },
    );

    dialogRef.afterClosed().subscribe(() => {
      if (this.router.url.includes('/dialog')) {
        void this.router.navigate(['../'], { relativeTo: this.route });
      }
    });
  }
}
